import useToastHook from './useToast';
import constate from 'constate';

export const [ToastProvider, useToast] = constate(useToastHook);
